export const TOKEN_KEY = "@MeuML-Token";
export const TOKEN_EXPIRE_IN = "@MeuML-Token-expire";
export const USER_ID = "@MeuML-UserId";
export const USER_NAME = "@MeuML-UserName";
export const USER_EMAIL = "@MeuML-UserEmail";
export const USER_SELLER_ID = "@MeuML-UserSellerId";
export const SYNC_ALL_LOG = "@MeuML-SyncAllLog";
export const SYNC_LOG = "@MeuML-SyncLog";
export const IS_ADMIN = "is_admin";
export const IS_SUPER_ADMIN = "@MeuML-SuperAdmin";
export const IMPERSONATING = "@MeuML-Impersonating";
export const ROUTING = "@MeuML#location";

export const login = (token, expire, email, is_admin, is_super_admin) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(TOKEN_EXPIRE_IN, expire);
  localStorage.setItem(USER_EMAIL, email);
  if(is_admin === true){
    localStorage.setItem(IS_ADMIN, is_admin);
  }
  if(is_super_admin === true){
    localStorage.setItem(IS_SUPER_ADMIN, true);
  }
};

export const isSuperAdmin = () => localStorage.getItem(IS_SUPER_ADMIN) === "true";
export const isImpersonating = () => !!localStorage.getItem(IMPERSONATING);
export const getImpersonatorEmail = () => localStorage.getItem(IMPERSONATING);

// Entra na impersonation: a identidade do ALVO passa a valer; o admin perde
// os flags enquanto impersona (isso esconde o menu e bloqueia aninhar pela UI).
export const enterImpersonation = ({ jwt, expire, targetEmail, targetName, targetId, isAdmin, impersonatorEmail }) => {
  localStorage.setItem(TOKEN_KEY, jwt);
  localStorage.setItem(TOKEN_EXPIRE_IN, expire);
  localStorage.setItem(USER_EMAIL, targetEmail);
  if (targetName != null) localStorage.setItem(USER_NAME, targetName);
  if (targetId != null) localStorage.setItem(USER_ID, targetId);
  // /impersonate NAO retorna seller_id -> remove o do admin p/ nao vazar.
  // USER_SELLER_ID indisponivel durante impersonation e estado esperado.
  localStorage.removeItem(USER_SELLER_ID);
  localStorage.removeItem(IS_SUPER_ADMIN);
  if (isAdmin === true) {
    localStorage.setItem(IS_ADMIN, true);
  } else {
    localStorage.removeItem(IS_ADMIN);
  }
  localStorage.setItem(IMPERSONATING, impersonatorEmail);
};

// Sai da impersonation: restaura a identidade do admin a partir da resposta
// do endpoint /stop (que reemite um token normal fresco do admin).
export const exitImpersonation = ({ jwt, expire, email, is_admin, is_super_admin }) => {
  localStorage.removeItem(IMPERSONATING);
  localStorage.setItem(TOKEN_KEY, jwt);
  localStorage.setItem(TOKEN_EXPIRE_IN, expire);
  localStorage.setItem(USER_EMAIL, email);
  if (is_admin === true) {
    localStorage.setItem(IS_ADMIN, true);
  } else {
    localStorage.removeItem(IS_ADMIN);
  }
  if (is_super_admin === true) {
    localStorage.setItem(IS_SUPER_ADMIN, true);
  } else {
    localStorage.removeItem(IS_SUPER_ADMIN);
  }
};

export const logout = () => {
  try {
    localStorage.removeItem(USER_EMAIL);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(USER_SELLER_ID);
    localStorage.removeItem(USER_ID);
    // localStorage.removeItem(SYNC_ALL_LOG);
    // localStorage.removeItem(SYNC_LOG);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_EXPIRE_IN);
    localStorage.removeItem(IS_ADMIN);
    localStorage.removeItem(IS_SUPER_ADMIN);
    localStorage.removeItem(IMPERSONATING);
    localStorage.removeItem(ROUTING);
    removeCategoriesFilter();
  } catch (error) {
    return error;
  }
};

function removeCategoriesFilter() {
  const categoriesFilter = JSON.stringify({
    page: 1,
    sortName: "id",
    sortOrder: "ASC",
    filter: "",
  });
  localStorage.setItem("filtro-categorias", categoriesFilter);
}

export const validateToken = () => {
  const newDate = new Date();
  const tokenDateExpire = new Date(getTokenExpire());

  return tokenDateExpire.getTime() >= newDate.getTime()
};

export const getTokenExpire = () => localStorage.getItem(TOKEN_EXPIRE_IN);
export const getToken = () => getFromStorageAndValidate(TOKEN_KEY);
export const getUserId = () => getFromStorageAndValidate(USER_ID);
export const getUserName = () => getFromStorageAndValidate(USER_NAME);
export const getUserEmail = () => getFromStorageAndValidate(USER_EMAIL);
export const getUserSellerId = () => getFromStorageAndValidate(USER_SELLER_ID);

function getFromStorageAndValidate(key) {
  if (validateToken()) {
    return localStorage.getItem(key);
  }
  logout();
  return {
    error: {
      message: "User has invalid token and must be kicked out from system.",
    },
  };
}
